import axios from 'axios';
import { generateHttpActions } from '../../../../../utility';

function getChatMessagesHttpRequest() {
  const functionName = 'chatMessages';

  const httpActions = generateHttpActions(functionName);
  const resource = `genai-assistant`;

  return async (dispatch) => {
    dispatch(httpActions.start());
    try {
      const response = await axios.get(resource, {});
      dispatch(httpActions.success(response));
    } catch (error) {
      dispatch(httpActions.error(error));
    }
  };
}

export default getChatMessagesHttpRequest;
